/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';
import Interp from '../geom/Interp';

export default class HeadGrow extends Phase {
	constructor(length, from, to) {
		super(length);
		this._interp = new Interp(from, to, from, [
			{ begin: 0, end: length, first: from, last: to }
		],
		x => Math.pow(x, 6));
	}
	getPreludeLength() {
		return 0;
	}
	getPostludeLength() {
		return null;
	}
	run({ time, pulse, headshot_opts }) {
		headshot_opts.scale = this._interp.get(time.relative);
	}
}
